import React from 'react';

import FormatSelect from './FormatSelect';

const FormatSelectContainer = ({
  readOnly,
  field,
  helpers,
}: {
  readOnly: any;
  field: any;
  helpers: any;
}) => {
  const handleItemClick = (itemValue: any) => {
    if (readOnly) {
      return;
    }

    helpers.setValue(itemValue);
  };

  return (
    <FormatSelect
      readOnly={readOnly}
      value={field.value}
      onItemClick={handleItemClick}
    />
  );
};

export default React.memo(FormatSelectContainer) as any;
